import api from '@/services/api'

export const getActionPlanFeed = async (actionPlanId) => {
    try {
        const resp = await api.get(`action-plans/${actionPlanId}/feed`, {
            params: {
                with: 'user;details;pdaCheckin;actionPlan',
            },
        })
        return await resp.data
    } catch (error) {
        console.error(error)
    }
}
